import height from '@public/_nextassets_/images/locationPages/height.webp';
import hideWire from '@public/_nextassets_/images/locationPages/hideWires.webp';
import mountTv from '@public/_nextassets_/images/locationPages/mountTv.webp';

export const BLOG_DETAILS = [
  {
    image: height,
    title: 'How High Should A TV Be Mounted?',
    link: 'https://www.hellotech.com/blog/how-high-should-a-tv-be-mounted',
    altText: 'height of a tv',
  },
  {
    image: hideWire,
    title: 'How To Hide TV Wires Without Cutting Your Walls.',
    link: 'https://www.hellotech.com/blog/how-to-hide-tv-wires-without-cutting-wall',
    altText: 'hidden tv wires',
  },
  {
    image: mountTv,
    title: 'How To Mount Your TV On Your Wall Properly.',
    link: 'https://www.hellotech.com/guide/for/how-to-mount-tv-on-wall',
    altText: 'proper mounting of tv',
  },
];

export const GUARANTEE_TEXTS = {
  title: 'Peace of Mind Guarantee',
  subTitle: "We're committed to your complete satisfaction with our service. If you're not 100% happy, we'll do whatever it takes to make it right.",
};

export const MEDIA_BLOCK = ({ isMobile }) => ({
  mediaImage: isMobile
    ? '/_nextassets_/images/locationPages/video-thumbail-mobile.webp'
    : '/_nextassets_/images/locationPages/video-thumbnail-desktop.webp',
  mediaUrl: 'https://www.youtube.com/embed/7-aswjALzyU',
  socialProofImage: '/_nextassets_/images/locationPages/social-proofs.png',
});

export const MEDIA_IMAGES = [
  '/_nextassets_/images/locationPages/PressLogos/usa-today.svg',
  '/_nextassets_/images/locationPages/PressLogos/wsj-wordmark.svg',
  '/_nextassets_/images/locationPages/PressLogos/abc.svg',
  '/_nextassets_/images/locationPages/PressLogos/cbs.svg',
  '/_nextassets_/images/locationPages/PressLogos/fortune.svg',
  '/_nextassets_/images/locationPages/PressLogos/tech-crunch.svg',
];

export const POPULAR_SERVICES = [
  {
    serviceName: 'TV Mounting',
    text: "We have TV mounting techs near you. We offer same-day TV mounting service backed by the HelloTech satisfaction guarantee. HelloTech experts are available 7 days a week to hang your TV perfectly and hide those ugly wires. Don't have a mounting bracket? We can bring one for you!",
    image: '/_nextassets_/images/locationPages/tv-mounting.webp',
    imageMobile: '/_nextassets_/images/locationPages/tv-mounting-mobile.webp',
    link: 'tv-mounting',
  },
  {
    serviceName: 'WiFi and Network Connectivity Support',
    text: "Tired of slow and spotty internet? Our expert techs know how to speed up slow internet. We'll fix your network connection, boost your WiFi signal, and give you the fastest internet possible. Does your WiFi keep dropping out? We will fix your WiFi, establishing a stable, secure connection. Having trouble with your devices? We will connect all of your mobile and smart devices to your WiFi network and make everything work seamlessly.",
    image: '/_nextassets_/images/locationPages/wifi-support.webp',
    imageMobile: '/_nextassets_/images/locationPages/wifi-support-mobile.webp',
    link: 'networking',
  },
  {
    serviceName: 'Smart Device Hook-up',
    text: "We'll connect your smart home to make sure all smart devices are working together. Trust the 5-star rated home automation service professionals. Installing products like smart doorbells, plugs, locks, alarms, switches, hubs, lights, thermostats and cameras. From brands like Nest, Arlo, Netgear, Skybell, Samsung, ecobee, Logitech, Iris, Google, Amazon, Ring, August, Honeywell and Sensi.",
    image: '/_nextassets_/images/locationPages/smart-device.webp',
    imageMobile: '/_nextassets_/images/locationPages/smart-device-mobile.webp',
    link: 'smart-home',
  },
  {
    serviceName: 'TV and Home Theater Support',
    text: 'Need help connecting your TV and home theater? Let one of our Techs work their audio video magic. We’ll hook up surround sound speakers, make sure you can stream videos, adjust any wiring, and make sure sound is functioning properly.',
    image: '/_nextassets_/images/locationPages/home-theater.webp',
    imageMobile: '/_nextassets_/images/locationPages/home-theater-mobile.webp',
    link: 'television-and-audio',
  },
  {
    serviceName: 'Computer Repair & Help',
    text: 'Need computer repair near you? HelloTech offers the highest quality computer repair service nationwide. Troubleshooting operating system, memory, RAM or hard drive issues. In-home or online help for your Mac or PC, on-demand.',
    image: '/_nextassets_/images/locationPages/computer-repair.webp',
    imageMobile: '/_nextassets_/images/locationPages/computer-repair-mobile.webp',
    link: 'computers',
  },
  {
    serviceName: 'Mobile-Device Support',
    text: "In-home support for your mobile Apple or Android device when you need it. Help with your phone, tablet troubleshooting, and more. We'll diagnose and fix your mobile problem.",
    image: '/_nextassets_/images/locationPages/mobile-support.webp',
    imageMobile: '/_nextassets_/images/locationPages/mobile-support-mobile.webp',
    link: 'mobile',
  },
];

export const SERVICE_TODAY_BLOCK = ({ isMobile }) => ({
  sectionImage: isMobile
    ? '/_nextassets_/images/locationPages/service-today-mobile.webp'
    : '/_nextassets_/images/locationPages/service-today-desktop.webp',
});
